<template>
  <div class="learningGeneral">
    <el-card>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="成绩排行" name="first" class="tab-type">
            <div>
              <div>
                <el-table
                  ref="multipleTable"
                  :data="modeList.records"
                  style="width: 100%;"
                  row-key="id"
                  border
                >
                  <el-table-column prop="questionTypeName" label="排名" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="title" show-overflow-tooltip label="学员姓名"></el-table-column>
                  <el-table-column prop="answer" label="考试得分" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="answer" label="做题时长" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column
                    prop="answer"
                    label="课堂练习/正确率"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="answer"
                    label="课后练习/正确率"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="prev, pager, next, jumper,  total, sizes"
                  style="margin-top: 20px;text-align: left;"
                  :total="modeList.total"
                  :page-size="modeList.pageSize"
                  :page-sizes="[10, 20, 30, 40]"
                  :current-page="modeList.pageNumber"
                  @size-change="studySizeChange"
                  @current-change="studyCurrentChange"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="错题分析" name="second" class="tab-type">
            <el-table
              ref="multipleTable"
              :data="errorAnalyseList.records"
              style="width: 100%;margin-top: 0px;"
              row-key="id"
              border
            >
              <el-table-column type="index" label="排序" width="50"></el-table-column>
              <el-table-column
                prop="question.questionTypeName"
                label="类型"
                width="100"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="question.title" show-overflow-tooltip label="题干">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.question!=undefined"
                    class="message"
                    @click="getInfoById(scope.row.questionId)"
                  >
                    <div class="htmltittle" v-html="scope.row.question.title"></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="question.answer"
                label="答案"
                align="center"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.big!=1">{{scope.row.question.answer||"-"}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="正确/已做" width="100" align="center"></el-table-column>
              <el-table-column label="正确率" width="100" align="center"></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev, pager, next, jumper,  total, sizes"
              style="margin-top: 20px;text-align: left;"
              :total="errorAnalyseList.total"
              :page-size="errorAnalyseList.pageSize"
              :page-sizes="[10, 20, 30, 40]"
              :current-page="errorAnalyseList.pageNumber"
              @size-change="errorAnalyseSizeChange"
              @current-change="errorAnalyseCurrentChange"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      modeList: {},
      modeSearch: {
        pageNumber: 1,
        pageSize: 10
      },
      errorAnalyseList: {},
        errorAnalyseSearch: {
        pageNumber: 1,
        pageSize: 10
      },
    };
  },
  computed: {},
  methods: {
    studySizeChange(pageSize) {
      this.modeSearch.pageSize = pageSize;
    },
    studyCurrentChange(pageNumber) {
      this.modeSearch.pageNumber = pageNumber;
    },
    errorAnalyseSizeChange(pageSize) {
      this.errorAnalyseSearch.pageSize = pageSize;
    },
    errorAnalyseCurrentChange(pageNumber) {
      this.errorAnalyseSearch.pageNumber = pageNumber;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name == "first") {
        this.getChapterMaterialsList(this.courseIds, 1);
      }
      if (tab.name == "second") {
        this.getChapterMaterialsList(this.courseIds, 2);
      }
      if (tab.name == "third") {
        this.getChapterMaterialsList(this.courseIds, 3);
      }
      if (tab.name == "fourth") {
        this.getChapterMaterialsList(this.courseIds, 4);
      }
      if (tab.name == "five") {
        this.getChapterMaterialsList(this.courseIds, 5);
      }
      if (tab.name == "six") {
        this.getChapterMaterialsList(this.courseIds, 6);
      }
    }
  },
  watch: {},
  mounted() {
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.learningGeneral {
  background-color: #fff;
}
.learningGeneral-left {
  width: 20%;
  border-right: 1px solid rgba(238, 238, 238, 1);
}
.learningGeneral-right {
  width: 80%;
}
.tab-type {
  padding: 20px;
  /* padding-top: 10px; */
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 48px;
  line-height: 48px;
}
.left-top-text {
  float: left;
}
.left-top-botton {
  margin-top: 10px;
  float: right;
}
.learningGeneral-search {
  padding: 0px 20px;
}
.learningGeneral-select {
  width: 100%;
  margin-top: 20px;
}
.learningGeneral-tree {
  font-size: 13px;
  margin-top: 20px;
  padding-bottom: 20px;
  color: #a2aabc;
}
.learningGeneral-icon {
  margin: 0px 10px;
  font-size: 18px;
  color: #409eff;
}
.classRoomButton {
  height: 32px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 14px;
}
.learningGeneral-analyse {
  padding: 20px;
  border: 1px solid rgba(238, 238, 238, 1);
  height: 80px;
}
.learningGeneral-number {
  font-size: 28px;
}
.analyse {
  margin-top: 10px;
  margin-bottom: 10px;
}
.learningGeneral-table {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/classStudy/modeDetail.vue